import { Spinner } from "react-bootstrap";
import {
    FaCheck,
    FaExclamationTriangle,
    FaQuestion,
    FaRegHourglass,
    FaTimes,
    FaTrash,
} from "react-icons/fa";

import {
    STATE_CANCELLED,
    STATE_DELETED,
    STATE_FAILED,
    STATE_MISSED,
    STATE_OMITTED,
    STATE_PENDING,
    STATE_RUNNING,
    STATE_SUCCEEDED,
} from "../../api/missionApi";

export default function StateIcon({ state, className, color }) {
    switch (state) {
        case STATE_PENDING:
            return (
                <FaRegHourglass
                    className={`text-${color ?? "primary"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_RUNNING:
            return (
                <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    className={`text-${color ?? "primary"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_SUCCEEDED:
            return (
                <FaCheck
                    className={`text-${color ?? "success"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_FAILED:
            return (
                <FaTimes
                    className={`text-${color ?? "danger"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_CANCELLED:
            return (
                <FaTimes
                    className={`text-${color ?? "secondary"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_DELETED:
            return (
                <FaTrash
                    className={`text-${color ?? "danger"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_OMITTED:
            return (
                <FaTimes
                    className={`text-${color ?? "secondary"} ${className}`}
                    style={{ marginTop: "-2px" }}
                />
            );
        case STATE_MISSED:
            return (
                <FaExclamationTriangle
                    className={className}
                    style={{ marginTop: "-2px", color: "#f07e27" }}
                />
            );
        default:
            return (
                <FaQuestion
                    className={className}
                    style={{ marginTop: "-2px" }}
                />
            );
    }
}
